import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { hasFlagsAdminPermission, isAdminLocalDev } from './adminAccess'

export { hasFlagsAdminPermission } from './adminAccess'

// The feature-flag admin surface (/admin/flags, RFC-0856 I7) accepts either the
// broad service-controlled admin role or the scoped "flags_admin" permission.
// The backend require_flags_admin 403 is the real boundary; local dev bypasses
// it only in the same auth-disabled mode as ProtectedRoute / AdminTopupRoute.
//
// Reads app_metadata ONLY — user_metadata is client-editable and must never gate
// an operator affordance. The claim is baked into the JWT at issue time, so a
// freshly granted operator only sees the route after a token refresh / re-login
// (accepted: the backend 403 stays authoritative until then).
//
export default function AdminFlagsRoute() {
  const { user, isLoading } = useAuth()
  if (isLoading) return null
  if (isAdminLocalDev() || hasFlagsAdminPermission(user)) return <Outlet />
  return <Navigate to="/dashboard" replace />
}
